import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenLoginAlert } from '@redux/auth/authSlice';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: ${props => props.theme.primaryColor};
    text-transform: capitalize;
}

.ant-modal-content {
    padding-top: 16px !important;
    text-align: center;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn {
        min-width: 76px;
    }
}
`;

const LoginAlert = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const open = useSelector(state => state.auth.openLoginAlert);

    const goToLogin = () => {
        handleClose();
        navigate(`/${PUBLIC_ROUTE.LOGIN}`);
    }

    const handleClose = () => dispatch(setOpenLoginAlert(false));

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            open={open}
            onCancel={handleClose}
            onOk={goToLogin}
            title={t("auth.unauthorized")}
            okText={t("auth.login")}
            cancelText={t("common.cancel")}
        >
            {t("auth.loginFirst")}
        </Modal>
    );
}

export default LoginAlert;